module.exports = __webpack_public_path__ + "static/img/1-首页主banner.a3cb5afc.jpg";